// extracted by mini-css-extract-plugin
export default {"card":"Card_card__3y7iZ","cardTitle":"Card_cardTitle__+9Hy9","key":"Card_key__4DSbQ"};